<template>
    <v-app>
        <core-toolbar/>
        <core-view/>
    </v-app>
</template>
<script>
    export default {
        created: function () {
            let self = this
            self.$http.interceptors.response.use(undefined, function (err) {
                return new Promise(function (resolve, reject) {
                    if (err.response.status === 403 && err.config && !err.config.__isRetryRequest) {
                        self.logout()
                    }
                    throw err;
                });
            });
        },
        methods: {
            logout: function () {
                window.location.href = '/logout/'
            },
        }
    }
</script>
<style lang="scss">
    @import '@/styles/index.scss';

    /* Remove in 1.2 */
    .v-datatable thead th.column.sortable i {
        vertical-align: unset;
    }
</style>

